import React from 'react';
import GesDentImage from '../../../assets/logoGesDent.png';
import megatrend from '../../../assets/megatrend.png';
import Project1 from '../../../assets/project1.png';

import './projects.css';

const Projects = () => {
    return (
        <section id="projects">
            <h5>I make</h5>
            <h2>Projects</h2>
            <div className="projects">
                <div className="container">
                    <a href="https://megatrenddz.com/">
                        <img src={megatrend} alt="project 1" />
                        <h3 className='titleProject'>E-commerce</h3>
                    </a>
                    <p>Django</p>
                </div>
                <div className="container">
                    <a href="/AppMobile">
                        <img src={Project1} alt="project 1" />
                        <h3 className='titleProject'>App Mobile</h3>
                    </a>
                    <p>Flutter</p>
                </div>
                <div className="container">
                    <a href="/Cabinet">
                        <img src={GesDentImage} alt="project 1" />
                        <h3 className='titleProject'>Logiciel Gestion Cabinet</h3>
                    </a>
                    <p>C#</p>
                </div>
            </div>
        </section>
    );
};

export default Projects;
